'use client';

import routes from '@/app/routes';
import Breadcrumbs from '@/components/Breadcrumb';
import HeaderNavigator from '@/components/Navigator';
import { useParams, useSearchParams } from 'react-router-dom';
import ReviewReportProductionReportingWrapper from './wrapper';
import { replacePlaceholders } from '@/utils/helpers';

const ReviewReportProductionReportingPage: React.FC = () => {
  const { lineId } = useParams<{ lineId: string }>();
  const [searchParams] = useSearchParams();

  return (
    <>
      <HeaderNavigator title="Production report" />
      <Breadcrumbs
        items={[
          {
            label: 'Home',
            path: `${routes.PRODUCTION_REPORTING}?${searchParams.toString()}`,
          },
          {
            label: 'Production periods',
            path: replacePlaceholders(
              `${routes.PRODUCTION_REPORTING_ADD_PERIODS}?${searchParams.toString()}`,
              {
                lineId: lineId || '',
              }
            ),
          },
          { label: 'Production report' },
        ]}
        maxVisible={4}
        className="w-full fixed top-[112px]"
      />
      <ReviewReportProductionReportingWrapper />
    </>
  );
};

export default ReviewReportProductionReportingPage;
